import { render, staticRenderFns } from "./Formulario018B.vue?vue&type=template&id=268c24cd"
import script from "./Formulario018B.vue?vue&type=script&lang=js"
export * from "./Formulario018B.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports